import axios from "axios";

const filenameFromDisposition = (disposition) => {
  if (!disposition) return null;

  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ""));
    } catch {
      /* fall through to the plain form */
    }
  }

  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain ? plain[1].trim() : null;
};

export const saveBlob = (blob, filename) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => window.URL.revokeObjectURL(objectUrl), 100);
};

const assertNotErrorPayload = async (response) => {
  const type = response.data?.type ?? "";
  if (!type.includes("json")) return;

  let message = "The server did not return a file.";
  try {
    const parsed = JSON.parse(await response.data.text());
    message = parsed.message ?? parsed.error ?? parsed.status ?? message;
  } catch {
    /* keep the generic message */
  }
  throw new Error(message);
};

/**
 * Downloads `url` and saves it to disk.
 *
 * @param {string} url
 * @param {object} [options]
 * @param {string} [options.filename] Fallback name when the response carries no
 *   `Content-Disposition`.
 * @param {object} [options.config] Extra axios config (method, data, headers).
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const downloadFile = async (url, { filename = "download", config = {} } = {}) => {
  const response = await axios({
    method: "get",
    url,
    responseType: "blob",
    ...config,
  });

  await assertNotErrorPayload(response);

  saveBlob(
    response.data,
    filenameFromDisposition(response.headers?.["content-disposition"]) ?? filename,
  );

  return response;
};

export default downloadFile;
